module.exports = __webpack_public_path__ + "static/media/greenCircleCheck.c4cdefd5.svg";